
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAAB7UExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/0WC/4Ks/5u8/3aj/1GK/7TN/////1GL/+bv/+bu /6jE/83e/2mb/16T/2qb/12T/4Kr/4+0/3Wj/8DV/9rm/wAAAK2p2nMAAAASdFJOUwBAj9/PnyAQ kI/PQM/PjxDfP5LbpTEAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH 5wwEAzkiVKWJywAAAN1JREFUKM+NkmsXgiAMhhd5qawsJqB0Mcvq///DGJaESqf309hz3p1tDMBo xubcUxQn0Cld8AktU8siPqkV0QUPaAmQ8KAyiMOQwdo9sBBCKveeg0NlZVU63EN9qN46qiF0zFAc QKp5OlfVmYLSh5ocNR6O6kIRelB25ZprV/7mQUEpaQy6pUiMYVsj1nIMCzuhUFrYae8eREqpvjU1 HsX023RLGsyJtsvH01vRX+sz9LN47FPwdVpaClE4xDewDX92DFkYmvMMWpm5vvzXaUI+6WXp++aT eODesT3lX38IOJueHJp3AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIzLTEyLTA0VDAyOjMyOjE0KzAw OjAwNaideAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMy0xMi0wNFQwMjozMjoxNCswMDowMET1JcQA AAAodEVYdGRhdGU6dGltZXN0YW1wADIwMjMtMTItMDRUMDM6NTc6MzQrMDA6MDCCz9vkAAAAAElF TkSuQmCC"}})])
          )
        }
      }
    